import React, { useEffect, useState } from 'react';
import Header from '../Header/Header';
import VolunteeringCard from '../VolunteeringCard/VolunteeringCard';
import fakeData from '../../fakeData/fakeData';
import ShowEvents from '../Events/ShowEvents';
import Footer from '../Footer/Footer';
import Banner from '../Header/Banner';

const Home = () => {
	const [events, setEvents] = useState([]);
	useEffect(() => {
		fetch('https://immense-woodland-55916.herokuapp.com/events')
			.then((res) => res.json())
			.then((data) => setEvents(data));
	}, []);
	return (
		<div>
			<Header />
			<Banner />
			<div className="container">
				<div className="row">
					{fakeData.map((vlc) => (
						<VolunteeringCard vlc={vlc}></VolunteeringCard>
					))}
				</div>
			</div>
			<div className="container">
				<div className="row">
					{events.map((event) => (
						<ShowEvents event={event}></ShowEvents>
					))}
				</div>
			</div>
			<Footer />
		</div>
	);
};

export default Home;
